var React = require('react');

function StarIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m352-293 128-76 129 76-34-144 111-95-147-13-59-137-59 137-147 13 112 95-34 144ZM243-144l63-266L96-589l276-24 108-251 108 252 276 23-210 179 63 266-237-141-237 141Zm237-333Z"}));
}

StarIcon.defaultProps = {"height":"20px","viewBox":"0 -960 960 960","width":"20px","fill":"#4A5A75"};

module.exports = StarIcon;

StarIcon.default = StarIcon;
